<template>
  <v-card ref="info-window">
    <router-link :to="{ name: 'ImoveisDetalhesResumo', params: { id: imovel.id } }">
      <v-card-title primary-title class="pb-2">
        <div style="width: 100%;" class="subheading"><strong>{{ infoWindowContentApelido }}</strong></div>
        <div style="width: 100%;" v-if="infoWindowContentProprietario.length > 0" class="grey--text text--darken-2">{{ infoWindowContentProprietario }}</div>
      </v-card-title>
      <v-card-media v-if="infoWindowContentFoto.length > 0" :src="infoWindowContentFoto" height="170px" class="mb-3"></v-card-media>
      <v-card-text class="pt-0 pb-4">
        <v-layout row wrap>
          <v-flex xs12 class="mb-4">
            <div class="grey--text text--darken-2">{{ infoWindowContentEndereco }}</div>
          </v-flex>
          <v-flex xs12 sm6 class="info-coluna">
            <ListaVistoriaSituacao v-if="infoWindowContentVistoria" :situacao="infoWindowContentVistoria"></ListaVistoriaSituacao>
            <v-btn v-else outline block class="secondary secondary--text ma-0 caption">Sem vistoria</v-btn>
          </v-flex>
          <v-flex xs12 sm6 class="info-coluna">
            <v-btn outline block class="grey grey--text ma-0 caption">
              <template v-if="infoWindowContentTarefasPendentes === 1"><span class="headline">1 &nbsp;</span>tarefa</template>
              <template v-else-if="infoWindowContentTarefasPendentes > 1"><span class="headline">{{ infoWindowContentTarefasPendentes }} &nbsp;</span>tarefas</template>
              <template v-else>Sem tarefas</template>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </router-link>
  </v-card>
</template>

<script>
  import 'snazzy-info-window/dist/snazzy-info-window.min.css'
  import _ from 'lodash'
  import ListaVistoriaSituacao from '../Lista/ListaVistoriaSituacao'

  export default {
    props: ['marker', 'imovel'],
    components: {
      ListaVistoriaSituacao
    },
    data () {
      return {
        infoWindowContentApelido: '',
        infoWindowContentProprietario: '',
        infoWindowContentEndereco: '',
        infoWindowContentFoto: '',
        infoWindowContentVistoria: '',
        infoWindowContentTarefasPendentes: ''
      }
    },
    mounted () {
      this.infoWindowContentApelido = this.imovel.apelido
      this.infoWindowContentProprietario = (this.imovel.proprietario ? this.imovel.proprietario : '')
      this.infoWindowContentEndereco = this.formatarEndereco(this.imovel.endereco.data)
      this.infoWindowContentFoto = (this.imovel.fotos ? this.formatarFotos(this.imovel.fotos.data) : '')
      this.infoWindowContentVistoria = (this.imovel.vistoria ? this.imovel.vistoria.data.situacao : '')
      this.infoWindowContentTarefasPendentes = (this.imovel.tarefas ? this.countTarefasPendentes(this.imovel.tarefas.data) : '')

      let SnazzyInfoWindow = require('snazzy-info-window')
      var info = new SnazzyInfoWindow({
        marker: this.marker,
        content: this.$refs['info-window'],
        placement: 'bottom',
        closeWhenOthersOpen: true,
        panOnOpen: true,
        showCloseButton: false,
        border: false,
        borderRadius: '12px',
        padding: '0px',
        callbacks: {
          afterOpen: () => {
            if (document.getElementsByClassName('si-float-wrapper').length > 0) {
              document.getElementsByClassName('mapa_botoes')[0].style.opacity = 0
            }
          },
          afterClose: () => {
            if (document.getElementsByClassName('si-float-wrapper').length === 0) {
              document.getElementsByClassName('mapa_botoes')[0].style.opacity = 1
            }
          }
        }
      })

      info.open()
    },
    methods: {
      formatarEndereco (endereco) {
        const logradouro = _.filter([`${endereco.tipo} ${endereco.logradouro}`, endereco.numero, endereco.complemento]).join(', ')
        const cidade = _.filter([logradouro, endereco.cidade, endereco.uf]).join(' - ')

        return cidade
      },
      formatarFotos (fotos) {
        const ilustrativa = _.filter(fotos, (item) => {
          return item.tipo === 'ilustrativa'
        })

        if (ilustrativa.length > 0) {
          return ilustrativa[0].foto
        } else {
          return ''
        }
      },
      countTarefasPendentes (tarefas) {
        return _.filter(tarefas, { realizada: false }).length
      }
    }
  }
</script>

<style>
  .si-float-wrapper { width: 100vw !important; max-width: 400px; }
  .si-wrapper-bottom { width: calc(100% - 20px); max-width: 400px; }
  .si-wrapper-bottom * { z-index: 999 !important; }
  .si-content { max-width: 100% !important; width: 100% !important; }

  @media (max-width: 599px) {
    .info-coluna + .info-coluna {
      margin-top: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// MapaInfoWindow.vue?34093de9